import script from "./NotesComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./NotesComponent.vue?vue&type=script&setup=true&lang=js"

import "./NotesComponent.vue?vue&type=style&index=0&id=9e5424a6&scoped=true&lang=css"

import exportComponent from "E:\\GCM3\\Demo\\demo-legacy-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9e5424a6"]])

export default __exports__